import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

export default function dateLabel({ startDate, endDate }, t) {
  return startDate && endDate ? `${dayjs(startDate).format('DD/MM/YYYY')} ${t('to')} ${dayjs(endDate).format('DD/MM/YYYY')}` : null;
}
